main.dropdown = (function () {
    var triggers = document.querySelectorAll('.js-dropdown-trigger');

    var init = function () {
        for (var i = triggers.length - 1; i >= 0; i--) {
            _addListeners(triggers[i]);
        }
    };

    var _addListeners = function (trigger) {
        var dropdown = trigger.querySelector('.c-nav--dropdown');
        dropdown.style.display = 'none';

        if (main.utils.viewport().width < 768) {
            TweenLite.set(dropdown, {
                height: 0,
            });
        } else {
            TweenLite.set(dropdown, {
                opacity: 0,
            });
        }

        trigger.addEventListener('mouseenter', function(e){
            _showDropdown();
            // popper.scheduleUpdate();
        });

        trigger.addEventListener('mouseleave', function(e){
            var target = e.toElement ? e.toElement : e.explicitOriginalTarget;

            if (typeof(target) !== 'undefined' || target.nodeType !== 1) {
                _hideDropdown();
                return;
            }

            if (!target.offsetParent) {
                _hideDropdown();
                return;
            }

            if (!target.isEqualNode(dropdown) && !target.offsetParent.isEqualNode(dropdown)) {
                _hideDropdown();
            }
        });

        dropdown.addEventListener('mouseleave', function(e){
            var target = e.toElement ? e.toElement : e.explicitOriginalTarget;

            if (!target.isEqualNode(trigger)) {
                _hideDropdown();
            }
        });

        function _showDropdown() {
            dropdown.style.display = 'block';

            if (main.utils.viewport().width < 768) {

                TweenLite.set(dropdown, {
                  height: 'auto'
                });

                TweenLite.from(dropdown, 0.44, {
                    height: 0,
                });
            } else {
                TweenLite.to(dropdown, 0.44, {
                    opacity: 1,
                });
            }
        }

        function _hideDropdown() {
            if (main.utils.viewport().width < 768) {
                TweenLite.to(dropdown, 0.44, {
                    height: 0,
                });
            } else {
                TweenLite.to(dropdown, 0.44, {
                    opacity: 0,
                    onComplete: function() {
                        dropdown.style.display = 'none';
                    }
                });
            }
        }
    };

    return {
        init: init
    };
})();
